export default {
  submitButton: {
    id: 'funnel_address_confirmation_page_submit_button',
    defaultMessage: 'Next',
  },
  collectionPointUnavailableTitle: {
    id: 'in_store_funnel_address_delivery_collection_point_unavailable',
    defaultMessage: 'Collection point delivery unavailable',
  },
  collectionPointUnavailableDescription: {
    id: 'in_store_funnel_address_delivery_collection_point_unavailable_description',
    defaultMessage:
      'This delivery option is not available for your order. Please choose another delivery method.',
  },
}
